/**
 * 自定义全局指令
 */
import Vue from 'vue'

/**
 * 百度统计事件统计
 * API介绍
 * 用于触发某个事件，如某个按钮的点击，或播放器的播放/停止，以及游戏的开始/暂停等。
 * 事件跟踪的数据不会被记入到页面PV中，适合用来统计所有的不需要看做PV的页面事件点击。
 * 已有数据的事件可以在设置中添加为事件转化，跟更多维度数据结合（如来源、入口页面等），进行转化分析。
 * @param category - 要监控的目标的类型名称，通常是同一组目标的名字，比如”视频”、”音乐”、”软件”、”游戏”等等。该项必选。
 * @param action - 用户跟目标交互的行为，如”播放”、”暂停”、”下载”等等。该项必选。
 * @param opt_label - 事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项可选。
 * @param opt_value - 事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据。该项可选。
 */
Vue.directive('bd-track-event', {
    bind (el, binding) {
        el.addEventListener('click', () => {
            if (!(binding.value instanceof Array)) return;
            window._hmt && window._hmt.push(['_trackEvent', ...binding.value]);
        });
    }
});
/**
 * clamp为多行超出部分省略号
 * 默认3行
 */
Vue.directive('clamp', {
    // 当被绑定的元素插入到 DOM 中时……
    bind: function (el, binding) {
       function  clamp(element, options) {
            options.clamp = options.clamp || 3
            var self = this,
                win = window,
                opt = {
                    clamp: options.clamp || 2,
                    useNativeClamp: typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
                    splitOnChars: options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
                    animate: options.animate || false,
                    truncationChar: options.truncationChar || '…',
                    truncationHTML: options.truncationHTML
                },

                sty = element.style,
                originalText = element.innerHTML,

                supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
                clampValue = opt.clamp,
                isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
                truncationHTMLContainer;
            if (opt.truncationHTML) {
                truncationHTMLContainer = document.createElement('span');
                truncationHTMLContainer.innerHTML = opt.truncationHTML;
            }


            // UTILITY FUNCTIONS __________________________________________________________

            /**
             * Return the current style for an element.
             * @param {HTMLElement} elem The element to compute.
             * @param {string} prop The style property.
             * @returns {number}
             */
            function computeStyle(elem, prop) {

                if (!win.getComputedStyle) {
                    win.getComputedStyle = function(el, pseudo) {
                        this.el = el;
                        this.getPropertyValue = function(prop) {
                            var re = /(\-([a-z]){1})/g;
                            if (prop == 'float') prop = 'styleFloat';
                            if (re.test(prop)) {
                                prop = prop.replace(re, function() {
                                    return arguments[2].toUpperCase();
                                });
                            }
                            return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
                        };
                        return this;
                    };
                }

                return win.getComputedStyle(elem, null).getPropertyValue(prop);
            }

            /**
             * Returns the maximum number of lines of text that should be rendered based
             * on the current height of the element and the line-height of the text.
             */
            function getMaxLines(height) {
                var availHeight = height || element.clientHeight,
                    lineHeight = getLineHeight(element);

                return Math.max(Math.floor(availHeight / lineHeight), 0);
            }

            /**
             * Returns the maximum height a given element should have based on the line-
             * height of the text and the given clamp value.
             */
            function getMaxHeight(clmp) {
                var lineHeight = getLineHeight(element);
                return lineHeight * clmp;
            }

            /**
             * Returns the line-height of an element as an integer.
             */
            function getLineHeight(elem) {
                var lh = computeStyle(elem, 'line-height');

                if (lh == 'normal') {
                    // Normal line heights vary from browser to browser. The spec recommends
                    // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
                    lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
                }
                return parseInt(lh);
            }


            // MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
            var splitOnChars = opt.splitOnChars.slice(0),
                splitChar = splitOnChars[0],
                chunks,
                lastChunk;

            /**
             * Gets an element's last child. That may be another node or a node's contents.
             */
            function getLastChild(elem) {
                //Current element has children, need to go deeper and get last child as a text node
                if (elem.lastChild.children && elem.lastChild.children.length > 0) {
                    return getLastChild(Array.prototype.slice.call(elem.children).pop());
                }
                //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
                else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue === '' || elem.lastChild.nodeValue == opt.truncationChar) {
                    elem.lastChild.parentNode.removeChild(elem.lastChild);
                    return getLastChild(element);
                }
                //This is the last child we want, return it
                else {
                    return elem.lastChild;
                }
            }

            /**
             * Removes one character at a time from the text until its width or
             * height is beneath the passed-in max param.
             */
            function truncate(target, maxHeight) {
                if (!maxHeight) {
                    return;
                }

                /**
                 * Resets global variables.
                 */
                function reset() {
                    splitOnChars = opt.splitOnChars.slice(0);
                    splitChar = splitOnChars[0];
                    chunks = null;
                    lastChunk = null;
                }

                var nodeValue = target.nodeValue.replace(opt.truncationChar, '');

                //Grab the next chunks
                if (!chunks) {
                    //If there are more characters to try, grab the next one
                    if (splitOnChars.length > 0) {
                        splitChar = splitOnChars.shift();
                    }
                    //No characters to chunk by. Go character-by-character
                    else {
                        splitChar = '';
                    }

                    chunks = nodeValue.split(splitChar);
                }

                //If there are chunks left to remove, remove the last one and see if
                // the nodeValue fits.
                if (chunks.length > 1) {
                    // console.log('chunks', chunks);
                    lastChunk = chunks.pop();
                    // console.log('lastChunk', lastChunk);
                    applyEllipsis(target, chunks.join(splitChar));
                }
                //No more chunks can be removed using this character
                else {
                    chunks = null;
                }

                //Insert the custom HTML before the truncation character
                if (truncationHTMLContainer) {
                    console.log(truncationHTMLContainer)
                    target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
                    element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
                }

                //Search produced valid chunks
                if (chunks) {
                    //It fits
                    if (element.clientHeight <= maxHeight) {
                        //There's still more characters to try splitting on, not quite done yet
                        if (splitOnChars.length >= 0 && splitChar !== '') {
                            applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
                            chunks = null;
                        }
                        //Finished!
                        else {
                            return element.innerHTML;
                        }
                    }
                }
                //No valid chunks produced
                else {
                    //No valid chunks even when splitting by letter, time to move
                    //on to the next node
                    if (splitChar === '') {
                        applyEllipsis(target, '');
                        target = getLastChild(element);

                        reset();
                    }
                }

                //If you get here it means still too big, let's keep truncating
                if (opt.animate) {
                    setTimeout(function() {
                        truncate(target, maxHeight);
                    }, opt.animate === true ? 10 : opt.animate);
                } else {
                    return truncate(target, maxHeight);
                }
            }

            function applyEllipsis(elem, str) {
                elem.nodeValue = str + opt.truncationChar;
            }


            // CONSTRUCTOR ________________________________________________________________

            if (clampValue == 'auto') {
                clampValue = getMaxLines();
            } else if (isCSSValue) {
                clampValue = getMaxLines(parseInt(clampValue));
            }

            var clampedText;
            if (supportsNativeClamp && opt.useNativeClamp) {

                sty.overflow = 'hidden';
                sty.textOverflow = 'ellipsis';
                sty.webkitBoxOrient = 'vertical';
                sty.display = '-webkit-box';
                sty.webkitLineClamp = clampValue;
                if (isCSSValue) {
                    sty.height = opt.clamp + 'px';
                }
            } else {

                var height = getMaxHeight(clampValue);

                if (height <= element.clientHeight) {
                    console.log(getLastChild(element));
                    clampedText = truncate(getLastChild(element), height);
                }
                /*        console.log(height,element,element,clampedText,555)*/
            }

            return {
                'original': originalText,
                'clamped': clampedText
            };
        }
        clamp(el,{clamp: binding.value})
    },

})



// WEBPACK FOOTER //
// ./app/directives/index.js